import { FC } from 'react';
import styles from './styles.module.css';
import errorIcon from '../../../assets/images/404.svg';

type Props = {
  error: PredefinedError | unknown;
};

type PredefinedError = {
  title: string;
  message: string;
};

/**
 * 汎用エラー
 */
const GeneralError: FC<Props> = ({ error }: Props) => {
  const { title, messages } = parseError(error);

  return (
    <div className={styles.host}>
      <img className={styles.icon} width="367" height="112" src={errorIcon} />
      {title && <div className={styles.title}>{title}</div>}
      {messages.map((m) => (
        <div className={styles.message} key={m}>
          {m}
        </div>
      ))}
    </div>
  );
};

export default GeneralError;

function parseError(x: unknown) {
  if (isPredefinedError(x))
    return {
      title: x.title,
      messages: x.message ? [x.message] : [],
    };
  return {
    title: '問題が発生しました',
    messages: [
      '申し訳ございませんが、不明な問題が発生しました。時間を空けて再度アクセスしてください。',
      String(x),
    ],
  };
}

function isPredefinedError(x: unknown): x is PredefinedError {
  if (!(typeof x === 'object' && x !== null)) return false;
  if (!('title' in x && typeof x.title === 'string')) return false;
  if (!('message' in x && typeof x.message === 'string')) return false;
  return true;
}
